<template>
  <div class="service-intro-container">
    <div class="service-intro-title mb-3">MAYACREW 핵심 서비스</div>
    <div :class="$vuetify.breakpoint.mdAndUp ? 'service-intro-subtitle mb-10' : 'service-intro-subtitle mb-6'">
      글로벌 시장 진출을 위한 전문 서비스로
      <div class="mobile"></div>
      여러분의 성공을 도와드립니다.
    </div>
    <div class="service-intro-content">
      <!-- Section 1 -->
      <div class="service-intro-section">
        <div class="header-section">
          <div class="logo-container">
            <div class="play-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4 2L13.3333 8L4 14V2Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <h2 class="header-title">숏폼 마케팅</h2>
          </div>
          <div class="badge">인지도 및 전환 확보</div>
        </div>

        <div class="description">
          인스타그램 릴스, 틱톡, 쇼츠 등을 활용한<span class="desktop" />
          인플루언서 마케팅
        </div>

        <div class="features-list">
          <div class="feature-item">
            <div class="check-icon">
              <v-icon color="white" size="16">mdi-check</v-icon>
            </div>
            <span>인플루언서 콘텐츠 제작</span>
          </div>
          <div class="feature-item">
            <div class="check-icon">
              <v-icon color="white" size="16">mdi-check</v-icon>
            </div>
            <span>기획 최적화</span>
          </div>
          <div class="feature-item">
            <div class="check-icon">
              <v-icon color="white" size="16">mdi-check</v-icon>
            </div>
            <span>고객 전환 증가</span>
          </div>
        </div>
      </div>
      <!-- Section 2 -->
      <div class="service-intro-section">
        <div class="header-section">
          <div class="logo-container">
            <div class="chart-icon">
              <svg width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.9974 4.66663L9.33073 10.3333L5.9974 6.99996L1.66406 11.3333"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M11 4.66663H15V8.66663"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <h2 class="header-title">북미 틱톡 어필리에이트</h2>
          </div>
          <div class="badge">매출 기여 증가</div>
        </div>

        <div class="description">
          북미 시장 진출을 위한 틱톡 어필리에이트 <span class="desktop" />
          마케팅 전략
        </div>

        <div class="features-list">
          <div class="feature-item">
            <div class="check-icon">
              <v-icon color="white" size="16">mdi-check</v-icon>
            </div>
            <span>크리에이터 무상 시딩 및 자동 수집</span>
          </div>
          <div class="feature-item">
            <div class="check-icon">
              <v-icon color="white" size="16">mdi-check</v-icon>
            </div>
            <span>리뷰 관리 및 연동</span>
          </div>
          <div class="feature-item">
            <div class="check-icon">
              <v-icon color="white" size="16">mdi-check</v-icon>
            </div>
            <span>GMV MAX</span>
          </div>
        </div>
      </div>
      <!-- Section 3 -->
      <div class="service-intro-section">
        <div class="header-section">
          <div class="logo-container">
            <div class="world-icon">
              <svg width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.66667 14.6667C12.3486 14.6667 15.3333 11.6819 15.3333 8.00004C15.3333 4.31814 12.3486 1.33337 8.66667 1.33337C4.98477 1.33337 2 4.31814 2 8.00004C2 11.6819 4.98477 14.6667 8.66667 14.6667Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M8.66667 1.33337C6.95482 3.13081 6 5.51787 6 8.00004C6 10.4822 6.95482 12.8693 8.66667 14.6667C10.3785 12.8693 11.3333 10.4822 11.3333 8.00004C11.3333 5.51787 10.3785 3.13081 8.66667 1.33337Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M2 8H15.3333" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <h2 class="header-title">일본 어필리에이트</h2>
          </div>
          <div class="badge">떠오르는 마케팅 트렌드</div>
        </div>

        <div class="description">일본 시장 특화 어필리에이트 마케팅<span class="desktop" /></div>

        <div class="features-list">
          <div class="feature-item">
            <div class="check-icon">
              <v-icon color="white" size="16">mdi-check</v-icon>
            </div>
            <span>일본 SNS 전채널 대응</span>
          </div>
          <div class="feature-item">
            <div class="check-icon">
              <v-icon color="white" size="16">mdi-check</v-icon>
            </div>
            <span>판매 성과에 따른 비용 정산</span>
          </div>
          <div class="feature-item">
            <div class="check-icon">
              <v-icon color="white" size="16">mdi-check</v-icon>
            </div>
            <span>구매 페이지까지 완벽 대행</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.service-intro-container {
  margin: 100px 0px;
  @media (max-width: 960px) {
    margin: 56px 16px;
  }
}

.service-intro-title {
  color: #21232e;
  text-align: center;
  font-size: 30px;
  font-style: normal;
  font-weight: 800;
  line-height: 42px; /* 140% */

  @media (max-width: 960px) {
    font-size: 24px;
    line-height: 32px; /* 133.333% */
  }
}

.service-intro-subtitle {
  color: #1b2b43;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */

  @media (max-width: 960px) {
    font-size: 14px;
    line-height: 24px; /* 171% */
  }
}

.service-intro-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.service-intro-section {
  display: flex;
  width: 100%;
  min-width: 328px;
  max-width: 349px;
  // height: 240px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);

  @media (max-width: 960px) {
    max-width: 458px;
  }
}

/* First Section Styles */
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.play-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #e91e63 0%, #ff6b9d 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.world-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #a855f7 0%, #6366f1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-title {
  color: #0a0a0a;
  font-size: 18px;
  font-weight: 700;
  line-height: 32px; /* 177.778% */
  letter-spacing: -0.6px;

  @media (max-width: 960px) {
    font-size: 16px;
    line-height: 32px; /* 200% */
  }
}

.badge {
  background: rgba(22, 109, 208, 0.05);
  color: #166dd0;
  padding: 4px 11px;
  border-radius: 16px;
  border: 1px solid rgba(22, 109, 208, 0.2);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
}

.description {
  color: #374151;
  font-size: 16px;

  height: 56px;
  font-weight: 400;
  line-height: 28px; /* 150% */

  @media (max-width: 960px) {
    height: auto;
    font-size: 14px;
    line-height: 24px; /* 171% */
  }
}

.main-text {
  color: #1b2b43;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
}

.features-list {
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
  width: 100%;
  color: #374151;
  border-radius: 8px;
  background-color: #fafafa;

  font-size: 16px;
  font-weight: 400;
  line-height: 24px; /* 150% */
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.check-icon {
  width: 20px;
  height: 20px;
  background: #2689ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-item span {
  color: #21232e;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;

  @media (max-width: 960px) {
    font-size: 14px;
  }
}
</style>
